import {changeFormat} from "@/components/tacho/common/CommonFunc";
import dayjs from "dayjs";
import {allCarDriverOpt} from "@/store/searchbar";

export const dateSelectTypes = {
    dateRange: 'dateRange',
    dateRangeWithMonthSwitch: 'dateRangeWithMonthSwitch',
    dateSingle: 'dateSingle',
};

function convertToTripMapper(props, searchBar, useLimitDate = false) {
    const params = {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        payType: searchBar.selectedPayType,
    };

    if (useLimitDate) {
        params.fromDtti = changeFormat(searchBar.selectedLimitDate.startIso, 'YYYYMMDDHHmmss');
        params.untilDtti = changeFormat(searchBar.selectedLimitDate.endIso, 'YYYYMMDDHHmmss');
    }

    return params;
}

function convertToDriverShiftMapper(props, searchBar) {
    return {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        status: 'CLOSE',
    };
}

function convertToOfficeShiftMapper(props, searchBar) {
    return {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        groupBy: searchBar.selectByMonth ? 'driver' : null,
    };
}

export function processPrivateSubmit(store, props, searchBar, useLimitDate = false) {
    if (!searchBar.privateCarNum) {
        return null;
    }

    const params = {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        carNum: searchBar.privateCarNum,
    };

    if (useLimitDate) {
        params.fromDtti = changeFormat(searchBar.selectedLimitDate.startIso, 'YYYYMMDDHHmmss');
        params.untilDtti = dayjs(searchBar.selectedLimitDate.endIso).subtract(1, 'second').format('YYYYMMDDHHmmss');
    }

    return params;
}

export async function processSubmits(store, props, searchBar, useLimitDate = false) {
    if (props.onSubmitPrivate) {
        const params = processPrivateSubmit(store, props, searchBar, useLimitDate);
        if (!params) {
            return;
        }
        return props.onSubmitPrivate(params);
    }

    if (!searchBar.selectedOffice || !searchBar.selectedCarNum) {
        return;
    }

    if (props.onSubmitTripQuery) {
        const params = convertToTripMapper(props, searchBar);
        return props.onSubmitTripQuery(params);
    }

    if (props.onSubmitTripQueryLimited) {
        const params = convertToTripMapper(props, searchBar, true);
        return props.onSubmitTripQueryLimited(params);
    }

    if (props.onSubmitDriverShiftQuery) {
        const params = convertToDriverShiftMapper(props, searchBar);
        return props.onSubmitDriverShiftQuery(params);
    }

    if (props.onSubmitOfficeShiftQuery) {
        const params = convertToOfficeShiftMapper(props, searchBar);
        return props.onSubmitOfficeShiftQuery(params);
    }
}

export function getOfficeShiftStartHours(office) {
    const validHours = [0];
    if (office.shiftStartHour > 0) {
        validHours.push(office.shiftStartHour);
    }
    return validHours;
}

export function isIsoValidForOffice(dateIso, office) {
    const validHours = getOfficeShiftStartHours(office);
    const dateJS = dayjs(dateIso);
    return validHours.indexOf(dateJS.hour()) !== -1;
}

export default {
    dateSelectTypes,
    processSubmits,
    getOfficeShiftStartHours,
    isIsoValidForOffice,
};
